import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './index.css';
import { IoClose } from 'react-icons/io5';

import homeicon from '../../assests/karaicon.svg';
import conceptSectionBg from '../../assests/conceptSectionBg.jpg';
import Footer from '../Footer';

import dragonflyImage1 from '../../assests/dragonfly-1.png';
import dragonflyImage2 from '../../assests/dragonfly-2.png';
import dragonflyImage3 from '../../assests/dragonfly-3.png';
import seawavesImage1 from '../../assests/seawaves-1.png';
import seawavesImage2 from '../../assests/seawaves-2.png';
import chairImage1 from '../../assests/chair-1.png';
import chairImage2 from '../../assests/chair-2.png';


const Concept1 = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isConceptOpen, setIsConceptOpen] = useState(false);

  const toggleConceptMenu = () => {
    setIsConceptOpen(!isConceptOpen);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Handle scroll behavior
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Navbar - Always Visible */}
      <nav className={`concept1-navbar ${isScrolled ? 'navbar-scrolled' : ''}`}>
        <div className="concept1-navbar-logo">
          <Link to="/">
            <img src={homeicon} alt="Kara Logo" className="concept1-logo-icon" />
          </Link>
        </div>
        <div className="concept1-navbar-menu" onClick={toggleMenu}>
          <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none" className="concept1-hamburger-icon">
            <circle cx="24.5" cy="24.5" r="24" fill="black" stroke="#9A9A9A"/>
            <rect x="13" y="16" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
            <rect x="13" y="23" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
            <rect x="13" y="30" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
          </svg>
        </div>
      </nav>

      {/* Navigation Menu Overlay */}
      {isMenuOpen && (
        <div className="concept1-nav-overlay">
          <div className="concept1-nav-close" onClick={toggleMenu}>
            <IoClose className="concept1-close-icon" />
          </div>
          <nav className="concept1-navigation">
            <ul className="concept1-nav-list">
              <li><Link to="/about" onClick={toggleMenu}>About US</Link></li>
              <li><Link to="/process" onClick={toggleMenu}>Our Process</Link></li>
              <li><Link to="/services" onClick={toggleMenu}>Services</Link></li>
              <li><Link to="/collections" onClick={toggleMenu}>Collections & Products</Link></li>
              <li><Link to="/sustainability" onClick={toggleMenu}>Sustainability & Ethical Sourcing</Link></li>
              <li><Link to="/private-client" onClick={toggleMenu}>Private Client Services</Link></li>
              {/* <li className="nav-item-with-submenu">
                <span  className="nav-concept-trigger" onClick={toggleConceptMenu}>
                  Concept <span className="dropdown-arrow">▼</span>
                </span>
                {isConceptOpen && (
                  <ul className="concept-submenu">
                    <li className="active"><Link to="/concept-1" onClick={toggleMenu}>Concept-1</Link></li>
                    <li><Link to="/concept-2" onClick={toggleMenu}>Concept-2</Link></li>
                  </ul>
                )}
              </li> */}
              <li className="active"><Link to="/concept" onClick={toggleMenu}>concept</Link></li>
              <li><Link to="/contact" onClick={toggleMenu}>Contact Us</Link></li>
            </ul>
          </nav>
        </div>
      )}

      {/* SECTION 1: Hero */}
      <section className="concept-section-1">
        <div className="concept-section-1-background">
          <img src={conceptSectionBg} alt="Concept Background" className="concept-section-1-bg-image" />
        </div>
        <div className="concept-section-1-overlay"></div>
        <div className="concept-section-1-content">
          <p className="concept-section-1-label">Our Concept</p>
        </div>
      </section>

      {/* SECTION 2: Dragonfly Dining Dialogue */}
      <section className="concept-section-2">
        <div className="concept-section-2-container">
          {/* Heading */}
          <h2 className="concept-section-2-heading">1. "Dragonfly" Dining Dialogue</h2>
          
          {/* Content Paragraphs */}
          <div className="concept-section-2-content">
            <p className="concept-section-2-text">
              An L-shaped teak table, grain-mapped to echo the rhythm of a living wall.
            </p>
            <p className="concept-section-2-text">
              The design is inspired by the graceful yet intricate structure of a dragonfly's wings. The delicate veins and organic patterns found in dragonfly wings serve as the foundation for this unique table design. The idea is to capture the beauty of nature's geometry and translate it into a functional, artistic piece of furniture.
            </p>
            <p className="concept-section-2-text">
              The interlocking sections of the tabletop create a sense of movement and fluidity, similar to the delicate structure of dragonfly wings. The pattern is both artistic and structural, with each segment fitting into place like puzzle pieces, enhancing the overall design while maintaining the natural flow of the wood.
            </p>
          </div>

          {/* Images Row */}
          <div className="concept-section-2-images">
            {/* First Image Container with Label */}
            <div className="concept-section-2-image-wrapper">
              <div className="concept-section-2-image-container-single">
                <img 
                  src={dragonflyImage1} 
                  alt="Dragonfly Table Design" 
                  className="concept-section-2-image-single"
                />
              </div>
              <p className="concept-section-2-image-label">Ideation</p>
            </div>

            {/* Second Image Container with Label */}
            <div className="concept-section-2-image-wrapper">
              <div className="concept-section-2-image-container-double">
                <img 
                  src={dragonflyImage2} 
                  alt="Dragonfly Table Detail 1" 
                  className="concept-section-2-image-left"
                />
                <img 
                  src={dragonflyImage3} 
                  alt="Dragonfly Table Detail 2" 
                  className="concept-section-2-image-right"
                />
              </div>
              <p className="concept-section-2-image-label">Concept</p>
            </div>
          </div>
        </div>
      </section>
      
      {/* SECTION 3: Soothing Flow of Sea Waves */}
      <section className="concept-section-3">
        <div className="concept-section-3-container">
          {/* Heading */}
          <h2 className="concept-section-3-heading">2. "Soothing Flow of Sea Waves"</h2>
          
          {/* Content Paragraphs */}
          <div className="concept-section-3-content">
            <p className="concept-section-3-text">
              This bed design draws its inspiration from the rhythmic, soothing flow of sea waves.
            </p>
            <p className="concept-section-3-text">
              The organic curves and natural movement of ocean waves are captured in the live edge structure of the bed, creating a harmonious blend of nature's fluidity and rustic elegance.
            </p>
            <p className="concept-section-3-text">
              Just as waves constantly evolve and reshape the shoreline, the bed design evokes a sense of tranquility and fluid motion.
            </p>
          </div>

          {/* Images Row */}
          <div className="concept-section-3-images">
            {/* First Image Container with Label */}
            <div className="concept-section-3-image-wrapper">
              <div className="concept-section-3-image-container-first">
                <img 
                  src={seawavesImage1} 
                  alt="Sea Waves Bed Design" 
                  className="concept-section-3-image-first"
                />
              </div>
              <p className="concept-section-3-image-label">Ideation</p>
            </div>

            {/* Second Image Container with Label */}
            <div className="concept-section-3-image-wrapper">
              <div className="concept-section-3-image-container-second">
                <img 
                  src={seawavesImage2} 
                  alt="Sea Waves Bed Concept" 
                  className="concept-section-3-image-second"
                />
              </div>
              <p className="concept-section-3-image-label">Concept</p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 4: The Chair */}
      <section className="concept-section-4">
        <div className="concept-section-4-container">
          {/* Heading */}
          <h2 className="concept-section-4-heading">3. "The Chair"</h2>
          
          {/* Content Paragraphs */}
          <div className="concept-section-4-content">
            <p className="concept-section-4-text">
              The chair's design is influenced by the spiral growth patterns and proportions found in nature through the Fibonacci sequence.
            </p>
            <p className="concept-section-4-text">
              Curves and angles are intentionally arranged to reflect the fluidity and balance inherent in this natural pattern, creating a visually appealing, ergonomically balanced seating experience.
            </p>
            <p className="concept-section-4-text">
              The chair's form gracefully follows the logic of nature's growth, blending artistry with practicality.
            </p>
          </div>

          {/* Images Row */}
          <div className="concept-section-4-images">
            {/* First Image Container with Label */}
            <div className="concept-section-4-image-wrapper">
              <div className="concept-section-4-image-container-first">
                <img 
                  src={chairImage1} 
                  alt="The Chair Design" 
                  className="concept-section-4-image-first"
                />
              </div>
              <p className="concept-section-4-image-label">Ideation</p>
            </div>

            {/* Second Image Container with Label */}
            <div className="concept-section-4-image-wrapper">
              <div className="concept-section-4-image-container-second">
                <img 
                  src={chairImage2} 
                  alt="The Chair Concept" 
                  className="concept-section-4-image-second"
                />
              </div>
              <p className="concept-section-4-image-label">Concept</p>
            </div>
          </div>
        </div>
      </section>
      
     <Footer/>

    </>
  );
};

export default Concept1;